// extracted by mini-css-extract-plugin
var _1 = "UserRow-module__animatedBackground--bu_u2";
var _2 = "UserRow-module__avatarContainer--JVn_C";
var _3 = "UserRow-module__badgeContainer--BvU7X";
var _4 = "UserRow-module__infoContainer--LQlpC";
var _5 = "UserRow-module__innerContainer--FHkUh";
var _6 = "UserRow-module__link--pF1x6";
var _7 = "UserRow-module__name--NLj_B";
var _8 = "UserRow-module__nameContainer--g3eJq";
var _9 = "UserRow-module__title--USq0O";
export { _1 as "animatedBackground", _2 as "avatarContainer", _3 as "badgeContainer", _4 as "infoContainer", _5 as "innerContainer", _6 as "link", _7 as "name", _8 as "nameContainer", _9 as "title" }
